// ── useUndoDeletes — удаление с «Отменить» (аудио, тексты, папки) ─────────────
// Удалённое сразу пропадает из списка, но по-настоящему удаляется (commit) только
// через 6 секунд, пока висит «… удалён · Отменить». «Отменить» вызывает restore —
// и ничего не удаляется. Закрыли вкладку раньше — удаляем сразу, чтобы устройство
// и сервер не разошлись (запрос может не успеть уйти — пользователь сам закрыл).
//   const deletes = useUndoDeletes();
//   deletes.enqueue({ type: 'audio', id, label, restore, commit });
//   deletes.items.map((e) => <UndoToast label={e.label} onUndo={() => deletes.undo(e.key)} />)

import { useCallback, useEffect, useRef, useState } from 'react';

export const UNDO_MS = 6000;

export default function useUndoDeletes() {
  const [items, setItems] = useState([]);
  const ref = useRef([]); // то же, что items, но сразу (для «Отменить» и закрытия вкладки)
  const set = (fn) => { ref.current = fn(ref.current); setItems(ref.current); };

  const enqueue = useCallback(({ type, id, label, restore, commit, duration = UNDO_MS }) => {
    const key = `${type}:${id}`;
    const timer = setTimeout(() => {
      try { commit(); } catch (e) { console.warn('[delete] commit:', e); }
      set((l) => l.filter((e) => e.key !== key));
    }, duration);
    set((l) => [...l, { key, type, id, label, restore, commit, timer }]);
  }, []);

  // restore — вне обновления состояния: React может вызвать обновление дважды
  // (StrictMode), и проект вернулся бы в список два раза.
  const undo = useCallback((key) => {
    const entry = ref.current.find((e) => e.key === key);
    if (!entry) return;
    clearTimeout(entry.timer);
    try { entry.restore(); } catch (e) { console.warn('[delete] restore:', e); }
    set((l) => l.filter((e) => e.key !== key));
  }, []);

  const waiting = items.length > 0;
  useEffect(() => {
    if (!waiting) return undefined;
    const commitAll = () => { ref.current.forEach((e) => { try { e.commit(); } catch { /* закрываемся */ } }); };
    window.addEventListener('beforeunload', commitAll);
    return () => window.removeEventListener('beforeunload', commitAll);
  }, [waiting]);

  return { items, enqueue, undo };
}
